'use client'

import {
  createContext,
  type FC,
  type ReactNode,
  useMemo,
  useState,
} from 'react'

import { useGlobalConfigContext } from '../../global-config'
import {
  initialRegistrationFormData,
  type RegistrationFormData,
} from '../registrationFormMakeRegistrationFormState'

interface LoginRegistrationUserRegistrationState {
  formData: RegistrationFormData
  hasVatNumber: boolean
  isProfessionalRegistration: boolean
  setFormData: (data: RegistrationFormData) => void
  setHasVatNumber: (hasVat: boolean) => void
}

// eslint-disable-next-line @typescript-eslint/no-empty-function -- the rule was disabled before a comment became required
const noop = (): void => {}

export const LoginRegistrationRegistrationStateContext =
  createContext<LoginRegistrationUserRegistrationState>({
    formData: initialRegistrationFormData(false),
    hasVatNumber: true,
    isProfessionalRegistration: false,
    setFormData: noop,
    setHasVatNumber: noop,
  })

interface LoginRegistrationRegistrationFormProviderProps {
  children: ReactNode
  isProfessionalRegistration: boolean
}

export const LoginRegistrationRegistrationStateProvider: FC<
  LoginRegistrationRegistrationFormProviderProps
> = ({ children, isProfessionalRegistration }) => {
  const [hasVatNumber, setHasVatNumber] = useState(true)
  const { tenant } = useGlobalConfigContext()
  const [formData, setFormData] = useState<RegistrationFormData>(
    initialRegistrationFormData(isProfessionalRegistration, tenant),
  )

  const value = useMemo(
    () => ({
      formData,
      hasVatNumber,
      isProfessionalRegistration,
      setFormData,
      setHasVatNumber,
    }),
    [
      setHasVatNumber,
      hasVatNumber,
      isProfessionalRegistration,
      formData,
      setFormData,
    ],
  )

  return (
    <LoginRegistrationRegistrationStateContext.Provider value={value}>
      {children}
    </LoginRegistrationRegistrationStateContext.Provider>
  )
}
